import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Button from "../Button";

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  color?: "default" | "red" | "yellow";
  isSubmitting?: boolean;
  type?: "button" | "reset" | "submit";
}

const SubmitButton: React.FC<Props> = ({
  color = "red",
  children,
  isSubmitting,
  onClick,
  type = "submit"
}) => {
  return (
    <Button
      className="submit-button"
      color={color}
      disabled={isSubmitting}
      onClick={onClick}
      type={type}
    >
      {children} {isSubmitting && <FontAwesomeIcon icon={faSpinner} spin />}
    </Button>
  );
};

export default SubmitButton;
